import type { WorkflowNodeExecution } from '@refly/openapi-schema';

export type CanvasNodeExecution = WorkflowNodeExecution & {
  executionId: string;
  startTime?: string | null;
};

const active = new Set(['executing', 'waiting_external', 'waiting_user']);
const time = (value?: string) => (value ? Date.parse(value) || 0 : 0);

export function selectCanvasNodeExecutions(rows: CanvasNodeExecution[]) {
  const selected = new Map<string, CanvasNodeExecution>();
  for (const row of rows) {
    // Finished records without startTime are copied upstream snapshots, not runs.
    if (row.status === 'finish' && !row.startTime) continue;
    const previous = selected.get(row.nodeId);
    const rank = (item: CanvasNodeExecution) =>
      active.has(item.status) ? 3 : item.status === 'init' ? 0 : 1;
    if (
      !previous ||
      rank(row) > rank(previous) ||
      (rank(row) === rank(previous) &&
        time(row.startTime || row.createdAt) > time(previous.startTime || previous.createdAt))
    ) {
      selected.set(row.nodeId, row);
    }
  }
  return [...selected.values()];
}
